var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "d-flex flex-column h-100",
      class: { disabled: _vm.isActive === false },
    },
    [
      _c("div", { staticClass: "sidebar-item" }, [
        _c(
          "div",
          {
            staticClass:
              "d-flex align-items-center gap-20 justify-content-between",
            on: { click: _vm.activate },
          },
          [
            _c("div", { staticClass: "d-flex gap-20 align-items-center" }, [
              _c(
                "span",
                {
                  staticClass: "main-number",
                  class: {
                    disabled: _vm.isActive === false,
                    done: _vm.isDone === true,
                  },
                },
                [_vm._v("2")]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "font-size-125" }, [
                _vm._v(_vm._s(_vm._f("trans")("Draw"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", {
              on: {
                click: function ($event) {
                  _vm.item_open = !_vm.item_open
                },
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("inpaint-nav"),
      _vm._v(" "),
      _c("div", { staticClass: "magic-canvas-outer-magic" }, [
        _c(
          "div",
          { staticClass: "w-100 h-100", attrs: { id: "magic-stage" } },
          [_c("magic-canvas")],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.activeStage.activeStep === "draw"
        ? _c("div", { staticClass: "sidebar-item border-top" }, [
            _c("div", { staticClass: "d-flex gap-40px flex-column" }, [
              _c("div", { staticClass: "d-flex gap-40px flex-column" }, [
                _c("div", { staticClass: "d-flex gap-20px flex-column" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "magic-toolbar d-flex w-100 gap-20px align-items-center",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "magic-tool",
                          class: {
                            active:
                              _vm.activeStage.canvas.activeTool ===
                              "freeDrawingBrush",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.setTool("freeDrawingBrush")
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "far fa-pencil" }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm._f("trans")("Brush"))),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "d-flex gap-20px w-100" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm._f("trans")("Brush width"))),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value:
                                _vm.activeStage.canvas.settings.freeDrawingBrush
                                  .width,
                              expression:
                                "activeStage.canvas.settings.freeDrawingBrush.width",
                              modifiers: { number: true },
                            },
                          ],
                          staticClass: "form-control-range range-slider flex-1",
                          attrs: {
                            type: "range",
                            id: "formControlRange",
                            min: "0",
                            max: "250",
                          },
                          domProps: {
                            value:
                              _vm.activeStage.canvas.settings.freeDrawingBrush
                                .width,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.setTool(
                                _vm.activeStage.canvas.activeTool
                              )
                            },
                            __r: function ($event) {
                              _vm.$set(
                                _vm.activeStage.canvas.settings
                                  .freeDrawingBrush,
                                "width",
                                _vm._n($event.target.value)
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex flex-column gap-40px" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-between gap-10" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "w-100 magic-action-btn",
                          class: {
                            disabled: _vm.activeStage.canvas.historyIndex <= 0,
                          },
                          on: { click: _vm.undo },
                        },
                        [
                          _c("i", { staticClass: "fa fa-redo fa-redo-undo" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("trans")("Undo")) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "w-100 magic-action-btn",
                          class: {
                            disabled:
                              _vm.activeStage.canvas.history.length ===
                              _vm.activeStage.canvas.historyIndex + 1,
                          },
                          on: { click: _vm.redo },
                        },
                        [
                          _c("i", { staticClass: "fa fa-redo" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("trans")("Redo")) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "next-btn",
                      class: { disabled: _vm.isDone === false },
                      on: { click: _vm.next },
                    },
                    [
                      _vm._v(_vm._s(_vm._f("trans")("Next"))),
                      _c("i", { staticClass: "fa lh-inherit fa-arrow-right" }),
                    ]
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }